/**
 * PortalLogin
 *
 * This handles clearing, getting, and setting data used by a user account for the duration of 
 * their session.
 */

// the constructor for this object
function PortalLogin() { }

// the object
PortalLogin.prototype = {
    constructor: PortalLogin,
    
    // the callback function that should be run after login data is set
    callback: false,
    
    // This stores info about what data to acquire from the api, how to acquire it, and how many attempts have been made to acquire it.
    _dataGrabs: [
        // {key, clearMethod, setMethod, status, attemptsToMake, attemptsMade}
    ],
    
    // set the default data grabs
    _setDataGrabs: function()
    {
        this._dataGrabs = [
            // {key, clearMethod, setMethod, status, attemptsToMake, attemptsMade}
            {
                key: 'user', 
                clearMethod: PortalMain.PortalUser.clearUser,
                setMethod: PortalMain.PortalUser.setUser,
                status: false, 
                attemptsToMake: 3, 
                attemptsMade: 0
            },
            {
                key: 'accounts', 
                clearMethod: PortalMain.PortalAccounts.clearAccounts,
                setMethod: PortalMain.PortalAccounts.setAccounts,
                status: false, 
                attemptsToMake: 3, 
                attemptsMade: 0
            },
            {
                key: 'products', 
                clearMethod: PortalMain.PortalProducts.clearProducts,
                setMethod: PortalMain.PortalProducts.setProducts,
                status: false, 
                attemptsToMake: 3, 
                attemptsMade: 0
            },
            {
                key: 'resourceCategories', 
                clearMethod: PortalMain.PortalResources.clearResourceCategories,
                setMethod: PortalMain.PortalResources.setResourceCategories,
                status: false, 
                attemptsToMake: 3, 
                attemptsMade: 0
            },
        ];
    },
    
    // grab data relevant to the user
    updateLoginData: function()
    {
        this._setDataGrabs();
        
        // clear the old data
        for (var i in this._dataGrabs) {
            this._dataGrabs[i].clearMethod();
        }
        
        // get the new data from the api
        for (var i in this._dataGrabs) {
            var key = this._dataGrabs[i].key;
            this._dataGrabs[i].setMethod(
                PortalMain.PortalLogin._getDataGrabCallback(key)
            );
        }
    },
    
    // get the callback to be run after each data grab
    _getDataGrabCallback: function(dataGrabKey)
    {
        return function(successStatus) {
            // get the object from _dataGrabStatuses
            for (var i in PortalMain.PortalLogin._dataGrabs) {
                var dataGrab = PortalMain.PortalLogin._dataGrabs[i];
                if (dataGrab.key == dataGrabKey) {
                    break;
                }
            }
            
            // increment the attemptsMade
            dataGrab.attemptsMade++;
            
            // set the current status
            dataGrab.status = successStatus;
            
            // run again if there is a failure, with a little time in between
            if (successStatus == false
            && dataGrab.attemptsMade < dataGrab.attemptsToMake) {
                setTimeout(
                    dataGrab.setMethod(
                        PortalMain.PortalLogin._getDataGrabCallback(dataGrab.key)
                    ),
                    300
                );
            }
            
            // check if all data has been acquired
            PortalMain.PortalLogin._checkDataGrabCompletion();
        }
    },
    
    // this is called after a data grab api request. See if all data grabs are complete
    _checkDataGrabCompletion: function()
    {
        // check if all api requests have checked in, and if attempts have been exhausted
        var completeSuccess = true;
        var completeFailure = false;
        for (var i in this._dataGrabs) {
            
            // if none of the statuses are false
            if (this._dataGrabs[i].status == false) {
                completeSuccess = false;
            }
            
            // if one of the statuses are false and have exhausted all request attempts
            if (this._dataGrabs[i].attemptsMade >= this._dataGrabs[i].attemptsToMake
            && this._dataGrabs[i].status == false) {
                completeFailure = true;
            }
        }
        
        // everything went splendidly
        if (completeSuccess) {
            // set the login date
            PortalMain.PortalLogin._storePortalLoginTime();
            
            // run the callback
            if (typeof PortalMain.PortalLogin.callback == 'function') {
                PortalMain.PortalLogin.callback();
            }
        }
        
        // one of the api requests failed out, log out and redirect
        if (completeFailure) {
            PortalMain.PortalLogin.logout();
            window.location.href = PortalConfig.portalUrl + '/login/user-data';
        }
        
    },
    
    // clear all data on logout
    logout: function()
    {
        PortalMain.PortalToken.clearToken();
        PortalMain.PortalUser.clearUser();
        PortalMain.PortalAccounts.clearAccounts();
        PortalMain.PortalProducts.clearProducts();
        PortalMain.PortalResources.clearResourceCategories();
        PortalMain.PortalLogin._clearPortalLoginTime();
    },
    
    // if the login data time has expired, update the login data
    checkLoginDataTime: function()
    {
        // if there is not a token, just run the callback
        if (!PortalMain.PortalToken.getToken()) {
            if (typeof this.callback == 'function') {
                this.callback();
            }
            return;
        }
        
        var currentTime = Math.floor(Date.now() / 1000);
        var loginTime = this._getPortalLoginTime();
        var difference = currentTime - loginTime;
        
        if (typeof this.callback == 'function'
        && (loginTime == false || difference < PortalConfig.loginDataRefreshTime)) {
            this.callback();
        } else {
            this.updateLoginData();
        }
    },
    
    // save the current timestamp
    _storePortalLoginTime: function()
    {
        var portalLoginTime = Math.floor(Date.now() / 1000);
        localStorage.setItem('portalLoginTime', portalLoginTime);
    },
    
    // clear the portal login time from localstorage
    _clearPortalLoginTime: function()
    {
        localStorage.removeItem('portalLoginTime');
    },
    
    // get the portal login time
    _getPortalLoginTime: function() 
    {
        if (localStorage.portalLoginTime) {
            return localStorage.portalLoginTime;
        }
        
        return false;
    },
    
    // change the portal login time to the past to force a login update
    forceLoginUpdateOnNextLoad: function()
    {
        var portalLoginTime = Math.floor(Date.now() / 1000) - PortalConfig.loginDataRefreshTime;
        localStorage.setItem('portalLoginTime', portalLoginTime);
    },
    
}
